import styled, { css } from 'styled-components';
import { media } from '../../layouts/utils';

export const ImgGooglePlay = styled.img`
  height: 38px;
  width: 127px;
`;

export const ImgAppStore = styled.img`
  height: 38px;
  width: 114px;
`;

export const ContainerMobileStores = styled.div`
  img {
    margin-right: 24px;
  }

  ${media.smallPhone &&
  css`
    display: flex;
    flex-direction: row;
  `}
`;
